'use client'

import { SessionProvider } from 'next-auth/react'

export const AuthProvider = ({ children }) => {
  return (
    <SessionProvider
      refetchInterval={60 * 60 * 8}
      refetchWhenOffline={false}
      refetchOnWindowFocus={false}
    >
      {children}
    </SessionProvider>
  )
}
